import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Navigation } from '@/components/layout/Navigation';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle, ArrowRight } from 'lucide-react';

const SubscriptionSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  return (
    <div className="min-h-screen bg-background" data-testid="subscription-success-page">
      <Navigation />
      
      <main className="max-w-lg mx-auto px-4 py-20 text-center">
        <Card className="border border-border">
          <CardContent className="pt-12 pb-8">
            <div className="w-20 h-20 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-10 h-10 text-emerald-600" />
            </div>
            
            <h1 className="text-3xl font-bold mb-4">
              Subscription Activated!
            </h1>
            
            <p className="text-muted-foreground mb-8">
              Thank you for subscribing. Your company account is now active with all premium features.
            </p>
            
            <div className="space-y-3">
              <Link to="/company">
                <Button className="w-full" data-testid="go-to-company-btn">
                  Go to Company Dashboard
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
              
              <Link to="/dashboard">
                <Button variant="outline" className="w-full">
                  Back to Dashboard
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default SubscriptionSuccessPage;
